import React, { FC, useState } from "react";
import { Building } from "../../../interfaces/Building";
import { IonButton, IonCol, IonContent, IonIcon, IonPopover, IonRow } from "@ionic/react";
import { isStaff } from "../../extras/Functions";
import { selectUser } from "../../../reducers/UserReducer";
import { useAppSelector } from "../../../Hooks";
import './BuildingOverview.css'
import EditSavingsDateModal from "../Modals/EditSavingsDateModal";
import { alertCircleSharp, createOutline } from "ionicons/icons";
import EditBaselineDateModal from "../Modals/EditBaselineDateModal";
import EditPeakPerformaceDateModal from "../Modals/EditPeakPerformaceDateModal";

interface IProps {
    building:Building
};

function get_baseline_date(month:string|number|null,year:string|number|null){
    const days = new Date(Number(year),Number(month),0)
    return `${year}-${month}-${days.getDate()}`
}

const BuildingOverview:FC<IProps> = ({building}) => {
    const user = useAppSelector(selectUser);
    const [data, setData] = useState({"savings_date":building.co_start_date,"baseline_date":building.baseline ? get_baseline_date(building.baseline?.month,building.baseline?.year) : ''})
    const [savingsModal, setSavingsModal] = useState(false)
    const [baselineDateModal, setBaselineDateModal] = useState(false)
    const [peakPerformanceModal, setPeakPerformanceModal] = useState(false)
    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';


    return <IonCol className="building-overview-data" size='12'>
                  <IonRow >
                    <IonCol size="12" sizeLg="6">
                        <IonRow>
                            <IonCol size="12" sizeMd=''>
                                <IonRow className="ion-justify-content-center ion-align-items-center ion-text-center"> <h2 className={newUI?'text-dark-blue':''}>Total Cost Avoidance</h2> </IonRow>
                                <div style={{ textAlign: "center" }}>{building.total_cost_avoidance ? `$${building.total_cost_avoidance?.toLocaleString("en")}`:'None'}</div>                                
                            </IonCol>
                            <IonCol size="12" sizeMd=''>
                                <IonRow className="ion-justify-content-center ion-align-items-center ion-text-center"> <h2 className={newUI?'text-dark-blue':''}>Utility Costs Reduction </h2>                                    
                                </IonRow>
                                <div style={{display:'flex',justifyContent:'center', textAlign: "center" }}>{
                                    typeof building.utility_cost_percent_reduction === "object" ? 
                                    <div style={{position:'relative',width:'fit-content'}}>
                                        None 
                                        <IonIcon id="context-menu-trigger" className="alert-icon-top-right" src={alertCircleSharp}></IonIcon>
                                        <IonPopover trigger="context-menu-trigger" side="right" alignment="center">
                                        <IonContent class="ion-padding">
                                            <div style={{color:'red'}}>Error:</div>
                                            <div>{building.utility_cost_percent_reduction['error']}</div>
                                        </IonContent>
                                    </IonPopover>
                                    </div> :
                                    building.utility_cost_percent_reduction?.toLocaleString('en')+'%'
                                    }</div>
                                <IonRow className="ion-justify-content-center ion-align-items-center">
                                    <div style={{ fontSize:"12px",display:'flex',alignItems:'center'}}>{building.pp_end_date ? building.pp_end_date?.toLocaleString('en') : 'No Date'}
                                    <IonButton
                                        hidden={!isStaff(user)}
                                        id="edit-building"
                                        fill="clear"
                                        color="light"
                                        slot="icon-only"
                                        className="small-edit-icon"
                                        onClick={()=>setPeakPerformanceModal(true)}
                                        title="Edit Peak Performance Date"
                                    >                                        
                                        <IonIcon slot="icon-only" src={createOutline}></IonIcon>
                                    </IonButton>
                                    </div>
                                </IonRow>
                            </IonCol>
                            <IonCol  size="12" sizeMd=''>
                                <IonRow className="ion-justify-content-center ion-align-items-center"> <h2 className={newUI?'text-dark-blue':''}>Project Fee</h2> </IonRow>
                                <div style={{ textAlign: "center" }}>{building.project_fee ? `$${building.project_fee?.toLocaleString("en")}`:'None'}</div>
                            </IonCol>
                            <IonCol size="12" sizeMd=''>
                                <IonRow className="ion-justify-content-center ion-align-items-center"> <h2 className={newUI?'text-dark-blue':''}>Incentives</h2> </IonRow>
                                <div style={{ textAlign: "center" }}>{building.building_incentive ? `$${building.building_incentive?.toLocaleString("en")}`:'None'}</div>
                            </IonCol>
                            {/* <IonCol size="12" sizeMd=''>
                                <IonRow className="ion-justify-content-center ion-align-items-center"> <h2>Price Per Square Foot</h2> </IonRow>
                                <div style={{ textAlign: "center" }}>
                                    { building.baseline && building.baseline.score ?
                                    `$
                                    ${Math.round(
                                        (Number(building.baseline?.score?.energycost) /
                                        Number(building.building_sq_ft)) *
                                        100
                                    ) / 100}
                                /sf`: 'N/A'}
                                </div>
                            </IonCol> */}
                        </IonRow>
                    </IonCol>
                    <IonCol size="12" sizeLg="6">
                        <IonRow>
                            <IonCol size="12" sizeMd=''>
                                <IonRow className="ion-justify-content-center ion-align-items-center"> <h2 className={newUI?'text-dark-blue':''}>Baseline End Date</h2>
                                    <IonButton
                                        hidden={!isStaff(user)}
                                        id="edit-building"
                                        fill="clear"
                                        color={newUI?'dark':'light'}
                                        // slot="icon-only"
                                        // className="testing"
                                        onClick={()=>setBaselineDateModal(true)}
                                    >
                                        <IonIcon slot="icon-only" src={createOutline}></IonIcon>
                                    </IonButton>
                                </IonRow>
                                <div style={{ textAlign: "center" }}>{building.baseline ? data.baseline_date : 'No Baseline Set'}</div>
                            </IonCol>
                            <IonCol size="12" sizeMd=''>
                                <IonRow className="ion-justify-content-center ion-align-items-center"> <h2 className={newUI?'text-dark-blue':''}>Savings Start Date</h2>
                                    <IonButton
                                        hidden={!isStaff(user)}
                                        id="edit-building"
                                        fill="clear"
                                        color={newUI?'dark':'light'}
                                        // slot="icon-only"
                                        // className="testing"
                                        onClick={()=>setSavingsModal(true)}
                                    >
                                        <IonIcon slot="icon-only" src={createOutline}></IonIcon>
                                    </IonButton>
                                </IonRow>
                                <div style={{ textAlign: "center" }}>{data.savings_date?.toLocaleString('en')}</div>
                            </IonCol>                            
                            <IonCol size="12" sizeMd=''>
                                <IonRow className="ion-justify-content-center ion-align-items-center"> <h2 className={newUI?'text-dark-blue':''}>Energy Utilization Index (EUI):</h2></IonRow>
                                <div style={{ textAlign: "center" }}>{building.baseline
                                    ? building.baseline.score?.site_eui
                                    : "N/A"}
                                    </div>
                                </IonCol>
                        </IonRow>
                    </IonCol>
                  </IonRow>
                  <EditSavingsDateModal opened={savingsModal} setOpened={setSavingsModal} date = {data.savings_date} id = {building.uuid} setData={setData}/>
                  <EditBaselineDateModal opened={baselineDateModal} setOpened={setBaselineDateModal} date={data.baseline_date} id={building.uuid} setData={setData} />
                  <EditPeakPerformaceDateModal opened={peakPerformanceModal} setOpened={setPeakPerformanceModal} date={building.pp_end_date} id={building.uuid}/>
            </IonCol>
};

export default BuildingOverview;